"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeEnum1 = void 0;
/**
 * event type\'s name
 * @export
 * @enum {string}
 */
var EventTypeEnum1;
(function (EventTypeEnum1) {
    EventTypeEnum1["Welcome"] = "WELCOME";
    EventTypeEnum1["ChangeCluster"] = "CHANGE_CLUSTER";
    EventTypeEnum1["Fidelity"] = "FIDELITY";
    EventTypeEnum1["Login"] = "LOGIN";
    EventTypeEnum1["SocialLogin"] = "SOCIAL_LOGIN";
    EventTypeEnum1["Wallet"] = "WALLET";
    EventTypeEnum1["Pattern"] = "PATTERN";
    EventTypeEnum1["Pda"] = "PDA";
    EventTypeEnum1["Keylist"] = "KEYLIST";
    EventTypeEnum1["Sdg"] = "SDG";
    EventTypeEnum1["Survey"] = "SURVEY";
    EventTypeEnum1["Birthday"] = "BIRTHDAY";
    EventTypeEnum1["Contest"] = "CONTEST";
    EventTypeEnum1["MgmReferrer"] = "MGM_REFERRER";
    EventTypeEnum1["MgmReferred"] = "MGM_REFERRED";
    EventTypeEnum1["Action"] = "ACTION";
})(EventTypeEnum1 = exports.EventTypeEnum1 || (exports.EventTypeEnum1 = {}));
